// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"hX","selections":"iX","pillsDesktopSearchMenu":"jX"};